import { createEnum } from '../actionTypesHelpers';

export const acceptFormat = createEnum({
  commonFileFormat: '.doc, .docx, .md, .pdf, .jpg, .png, .tiff',
  psmAuditFormat: '.pdf',
});
